import React, { useState } from "react";
import { ArrowRight, Mail } from "lucide-react";
import { Shell, PageHero, PageSection } from "../components/SiteLayout";

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const subject = encodeURIComponent(
      `Project inquiry: ${data.get("projectType") || "New project"}`,
    );
    const body = encodeURIComponent(
      `Name: ${data.get("name")}\nBusiness email: ${data.get("email")}\nCompany: ${data.get("company") || "Not provided"}\nProject type: ${data.get("projectType")}\nEstimated budget: ${data.get("budget") || "Not provided"}\nPreferred contact: ${data.get("preferredContact") || "Not specified"}\n\nProject description:\n${data.get("description")}`,
    );
    setSubmitted(true);
    window.location.href = `mailto:hello@rioz.dev?subject=${subject}&body=${body}`;
  }
  return (
    <Shell
      active="contact"
      seo={{
        title: "Contact RIOZ",
        description:
          "Discuss custom software, business systems, integrations, web applications, or infrastructure with RIOZ.",
        path: "/contact",
      }}
    >
      <PageHero
        title="Let’s talk about your project."
        description="Whether you need a custom application, a business system, a digital platform, or reliable infrastructure, tell us about your requirements."
      />
      <PageSection
        eyebrow="PROJECT INQUIRY"
        title="A few details to get started"
        intro="Share what you know so far. The budget and contact preferences are optional."
      >
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Full name
            <input name="name" autoComplete="name" required maxLength="120" />
          </label>
          <label>
            Business email
            <input
              name="email"
              type="email"
              autoComplete="email"
              required
              maxLength="200"
            />
          </label>
          <label>
            Company <span className="optional">(optional)</span>
            <input name="company" autoComplete="organization" maxLength="160" />
          </label>
          <label>
            Project type
            <span className="optional">(Select from dropdown)</span>
            <select name="projectType" required defaultValue="">
              <option value="" disabled>
                Select a project type
              </option>
              {[
                "Custom Software Development",
                "Business Information Systems",
                "Website / Web Application",
                "CMS / Content Management",
                "Integrations & Automation",
                "DevOps & Cloud Infrastructure",
                "Ongoing Development",
                "Other",
              ].map((x) => (
                <option key={x}>{x}</option>
              ))}
            </select>
          </label>
          <label>
            Estimated budget <span className="optional">(optional)</span>
            <select name="budget" defaultValue="">
              <option value="">Choose a range</option>
              {[
                "Under €1,000",
                "€1,000–€3,000",
                "€3,000–€7,500",
                "€7,500–€15,000",
                "€15,000+",
                "Not sure yet",
              ].map((x) => (
                <option key={x}>{x}</option>
              ))}
            </select>
          </label>
          <label>
            Preferred contact method{" "}
            <span className="optional">(optional)</span>
            <select name="preferredContact" defaultValue="">
              <option value="">No preference</option>
              <option>Email</option>
              <option>Phone (include number in description)</option>
            </select>
          </label>
          <label className="form-wide">
            Project description
            <textarea
              name="description"
              required
              minLength="20"
              maxLength="5000"
              rows="6"
              placeholder="What are you trying to improve, connect, or build?"
            />
          </label>
          <div className="form-wide form-submit">
            <button className="button-primary" type="submit">
              Send project inquiry <ArrowRight size={17} />
            </button>
            <p>
              This form prepares an email to hello@rioz.dev in your email app.
              It does not submit data to a server.
            </p>
            {submitted && (
              <p role="status">
                Your email app should open with the inquiry details. If it does
                not, email hello@rioz.dev directly.
              </p>
            )}
          </div>
        </form>
      </PageSection>
      <PageSection
        eyebrow="PREFER A DIRECT CONVERSATION?"
        title="Email RIOZ directly"
      >
        <a className="contact-link" href="mailto:hello@rioz.dev">
          <span className="contact-link-icon">
            <Mail size={20} />
          </span>
          <span>
            <small>START A CONVERSATION</small>
            <b>hello@rioz.dev</b>
          </span>
          <ArrowRight className="contact-arrow" size={19} />
        </a>
        <p className="privacy-copy">
          Please avoid sending passwords or sensitive personal information in
          your first message.
        </p>
      </PageSection>
    </Shell>
  );
}
